export default [
  {
    Agency: "Accountants One",
    Name: "Jared Elliot",
    Email: "jaredelliot@accountantsone.com",
  },
  {
    Agency: "Arete Partners",
    Name: "Ashley Gibbons",
    Email: "agibbons@rivierapartners.com",
  },
  {
    Agency: "Arete Partners",
    Name: "Chett Garcia",
    Email: "ctg@aretepartners.com",
  },
  {
    Agency: "Arete Partners",
    Name: "Eoin O'Toole",
    Email: "eo@aretepartners.com",
  },
  { Agency: "ASAP", Name: "Mark Gabriel", Email: "mgabriel@myasap.com" },
  {
    Agency: "Boulevard",
    Name: "Amie Barden",
    Email: "amie@boulevardrecruiting.com",
  },
  {
    Agency: "Boulevard",
    Name: "Ashlee Barden",
    Email: "abarden@boulevardrecruiting.com",
  },
  {
    Agency: "Boulevard",
    Name: "Cam Barnette",
    Email: "cameron@boulevardrecruiting.com",
  },
  {
    Agency: "Career Group Companies",
    Name: "Valerie Gard",
    Email: "vgard@careergroupinc.com",
  },
  {
    Agency: "Creative People",
    Name: "Tom Ogan",
    Email: "tom@creativepeopleinc.com",
  },
  {
    Agency: "Creative People",
    Name: "Rowan Clements",
    Email: "rowan@creativepeopleinc.com",
  },
  {
    Agency: "Edgewise Solutions",
    Name: "Irwin Solomon",
    Email: "isolomon@edgewisesolutions.com",
  },
  {
    Agency: "Elev8",
    Name: "Mike Peckham",
    Email: "mike@elev8staffing.com",
  },
  {
    Agency: "Elevano",
    Name: "Arash Bormand",
    Email: "arash.bormand@elevano.com",
  },
  { Agency: "Elevano", Name: "Alex Brown", Email: "abrown@elevano.com" },
  {
    Agency: "GCS Recruitment",
    Name: "Chris Dixon",
    Email: "chris.dixon@gcsrecruitment.com",
  },
  {
    Agency: "GCS Recruitment",
    Name: "Michael Luko",
    Email: "michael.luko@gcsrecruitment.com",
  },
  {
    Agency: "Genuent",
    Name: "Mina Landsberg",
    Email: "mlandsberg@genuent.com",
  },
  {
    Agency: "Genuent",
    Name: "Jordan Turner",
    Email: "jturner@genuent.com",
  },
  {
    Agency: "Glocomms",
    Name: "Dylan Finn",
    Email: "dylan.finn@glocomms.com",
  },
  {
    Agency: "Harnham",
    Name: "Calum Reid",
    Email: "calumreid@harnham.com",
  },
  {
    Agency: "Harnham",
    Name: "Joshua Poore",
    Email: "joshuapoore@harnham.com",
  },
  {
    Agency: "Intersect Group",
    Name: "Jamie Kaszowicz",
    Email: "jkaszowicz@theintersectgroup.com",
  },
  {
    Agency: "Intersect Group",
    Name: "Kristen Drake",
    Email: "kdrake@theintersectgroup.com",
  },
  {
    Agency: "Intersect Group",
    Name: "Robert Capizzi",
    Email: "rcapizzi@theintersectgroup.com",
  },
  {
    Agency: "Korn Ferry",
    Name: "Laurie Pearl",
    Email: "laurie.pearl@kornferry.com",
  },
  {
    Agency: "Korn Ferry",
    Name: "Malissa Mack",
    Email: "malissa.mack@kornferry.com",
  },
  {
    Agency: "Lucas Group",
    Name: "TJ Choquette",
    Email: "tchoquette@lucasgroup.com",
  },
  {
    Agency: "MRA Search",
    Name: "Ed McAlexander",
    Email: "ed@mrasearch.net",
  },
  {
    Agency: "Robert Half",
    Name: "Evan Ridarick",
    Email: "evan.ridarick@roberthalf.com",
  },
  {
    Agency: "Robert Walters",
    Name: "Karan Patel",
    Email: "karan.patel@robertwalters.com",
  },
  {
    Agency: "Russell Tobin",
    Name: "Christie Brady",
    Email: "christie.brady@russelltobin.com",
  },
  {
    Agency: "Vaco",
    Name: "Shannon Gwinner",
    Email: "sgwinnergh@vaco.com",
  },
  {
    Agency: "Visionaire",
    Name: "Todd Eichhorn",
    Email: "todd.eichhorn@visionairepartners.com",
  },
  {
    Agency: "Wolf Search",
    Name: "Tom Santolupo",
    Email: "tom@wolfsearchpartners.com",
  },
  {
    Agency: "Worth Search",
    Name: "Christian Fabros",
    Email: "christian@worthsearch.com",
  },
];
